/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlimitedactiveevents2Inputs */

const en_unlimitedactiveevents2 = /** @type {(inputs: Unlimitedactiveevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited parallel active events`)
};

const de_unlimitedactiveevents2 = /** @type {(inputs: Unlimitedactiveevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzt parallel aktive Events`)
};

/**
* | output |
* | --- |
* | "Unlimited parallel active events" |
*
* @param {Unlimitedactiveevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unlimitedactiveevents2 = /** @type {((inputs?: Unlimitedactiveevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlimitedactiveevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlimitedactiveevents2(inputs)
	return de_unlimitedactiveevents2(inputs)
});
export { unlimitedactiveevents2 as "unlimitedActiveEvents" }